import { render, staticRenderFns } from "./GbsHelpAddEditSingle.vue?vue&type=template&id=0b7d709a"
import script from "./GbsHelpAddEditSingle.vue?vue&type=script&lang=ts"
export * from "./GbsHelpAddEditSingle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports